export default __webpack_public_path__ + "68c5af1f48e2bfca1e57ae1c556a5c72.woff2";